import React from 'react';
import { motion } from 'framer-motion';
export function Differentiation() {
  return <section className="py-32 relative overflow-hidden flex items-center justify-center text-center" data-id="element-21">
      {/* Subtle gradient background shift */}
      <div className="absolute inset-0 bg-gradient-to-br from-navy via-surface/50 to-navy z-0" data-id="element-22" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-64 bg-primary/10 blur-[120px] rounded-full z-0" data-id="element-23" />

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-25">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-8 leading-tight tracking-tight" data-id="element-26">
            No Generamos Prospectos. Construimos Sistemas Que los{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary" data-id="element-27">
              Convierten en Clientes.
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed" data-id="element-28">
            La mayoría de las agencias te venden más tráfico. CONECKTA se
            asegura de que el tráfico que ya tienes se convierta en ingresos.
          </p>
        </motion.div>
      </div>
    </section>;
}